// extracted by mini-css-extract-plugin
var _1 = "IntegrationsPanelFact-moduletext__yR6MD";
export { _1 as "text" }
